import * as moment from 'moment';
import {
  FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS,
  IFiltersProgramArticleDashboard
} from '../actions/filters-program-article-dashboard.actions';

export const INITIAL_FILTERS_PROGRAM_ARTICLE_DASHBOARD_STATE: IFiltersProgramArticleDashboard = {
  startDate: moment().hours(0).minute(0).seconds(0).millisecond(0).toDate(),
  endDate: moment().hours(23).minute(59).seconds(59).millisecond(0).toDate(),
  selectedChannel: -1,
  defaultDestination: localStorage.getItem('defaultDestination'),
  midnightMode: false
};

export function filtersProgramArticleDashboardReducer(state: IFiltersProgramArticleDashboard = INITIAL_FILTERS_PROGRAM_ARTICLE_DASHBOARD_STATE, action) {
  switch (action.type) {

    case FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS.SET_DASHBOARD_DATES:
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.midnightMode = action.payload.midnightMode;
      return { ...state };

    case FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS.SET_DASHBOARD_FILTERS:
      return { ...action.payload };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/store/reducers/filters-program-article-dashboard.reducer.ts